module.exports = __webpack_public_path__ + "img/prices.362424e.svg";